<footer class="footer bg-white border-top" *ngIf="theming">
  <div class="container text-center py-3">
    <span class="text-muted">© {{ currentYear }} Mobydyg, </span>
    <span class="text-muted">v {{ theming?.version }}</span>
  </div>
</footer>